module.exports = __webpack_public_path__ + "static/img/avatar-s-1.8edbcded.png";